import React, { Component } from 'react';
import { Link } from '@reach/router';
import { Helmet } from 'react-helmet';
import { RichText } from 'prismic-reactjs';
import _ from 'lodash';
import { getProjectSlug } from '../utils/slugify';
import './ProjectPage.css';

class ProjectPage extends Component {
  state = { project: null, loaded: false };

  componentDidMount() {
    window.scrollTo(0, 0);
    this.fetchProject(this.props);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.prismicCtx !== this.props.prismicCtx ||
      prevProps.slug !== this.props.slug
    ) {
      this.fetchProject(this.props);
    }
  }

  fetchProject(props) {
    if (!props.prismicCtx) return;
    props.prismicCtx.api.query('', { pageSize: 100 }).then(response => {
      const project = _.find(
        response.results,
        doc => doc.type === 'project' && getProjectSlug(doc) === props.slug
      );
      this.setState({ project: project || null, loaded: true });
    });
  }

  render() {
    const { project, loaded } = this.state;

    if (!loaded) {
      return <div className="ProjectPage" />;
    }

    if (!project) {
      return (
        <div className="ProjectPage">
          <Helmet>
            <title>Project not found – Framo</title>
          </Helmet>
          <div className="ProjectPage-info">
            <Link to="/" className="ProjectPage-back">← Framo</Link>
            <p>This project could not be found.</p>
          </div>
        </div>
      );
    }

    const { data } = project;
    const title = RichText.asText(data.title);
    const description = RichText.asText(data.text)
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, 155);
    const url = `https://www.framo.studio/project/${this.props.slug}`;
    const images = (data.body || [])
      .filter(s => s.primary && s.primary.image && s.primary.image.url)
      .map(s => s.primary.image);

    return (
      <div className="ProjectPage">
        <Helmet>
          <title>{`${title} – Framo`}</title>
          <meta name="description" content={description} />
          <link rel="canonical" href={url} />
          <meta property="og:title" content={`${title} – Framo`} />
          <meta property="og:description" content={description} />
          <meta property="og:url" content={url} />
          {images[0] && <meta property="og:image" content={images[0].url} />}
        </Helmet>

        <div className="ProjectPage-info">
          <Link to="/" className="ProjectPage-back">← Framo</Link>
          <h1 className="ProjectPage-title">{title}</h1>
          <div className="ProjectPage-text">{RichText.render(data.text)}</div>
        </div>

        <div className="ProjectPage-images">
               {images.map((img, i) => (
            <img
              key={i}
                            src={img.url.split('?')[0] + '?auto=compress,format&q=90'}
              alt={img.alt || title}
            />
          ))}
        </div>
      </div>
    );
  }
}

export default ProjectPage;



// WEBPACK FOOTER //
// ./src/components/ProjectPage.js